import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSortDown = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.08105 14.5452V5H7.08105V14.6264L5.41421 12.9596L4 14.3738L7.33333 17.7071C7.72386 18.0976 8.35702 18.0976 8.74755 17.7071L12.0809 14.3738L10.6667 12.9596L9.08105 14.5452ZM13 17.9999L13 9.99994H15L15 17.9999H13ZM17 12.9999V17.9999H19V12.9999H17Z"
        />
      </svg>
    );
  }
);
